import { Link } from 'react-router-dom';

function Navbar({ onLogout }) {
  const user    = JSON.parse(localStorage.getItem('user') || '{}');
  const role    = user.role;
  const isAdmin = role === 'admin';
  // Chairman gets the full staff navigation (every module), but the
  // backend's authenticateToken middleware now blocks any non-GET
  // request from this role globally — so visibility here is safe even
  // though it mirrors the admin/finance/secretary nav exactly.
  const isChairman = role === 'chairman';
  const isStaff = ['admin', 'finance', 'secretary', 'chairman'].includes(role);
  const isMember = role === 'member';
  // Credit Officer is deliberately NOT part of isStaff — that block links
  // to every module. This role only has Dashboard, Loans, Treasury (and
  // Finance, which every authenticated role already sees) — see App.js's
  // CreditRoute for the matching route restriction.
  const isCreditOfficer = role === 'credit_officer';
  // Users and Jobs were previously admin-only links. Chairman now sees
  // them too (full oversight, per confirmed requirement) — clicking into
  // either page works, but any write action inside them is rejected by
  // the backend regardless of what's shown here.
  const canViewAdminLinks = isAdmin || isChairman;

  return (
    <nav style={{
      background: '#2c3e50',
      padding: '10px 20px',
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
      alignItems: 'center'
    }}>
      <span style={{ color: '#f39c12', fontWeight: 'bold', marginRight: '10px' }}>
        Kigezi Association
        {isChairman && <span style={{ marginLeft: '8px', fontSize: '11px', background: '#8e44ad', color: 'white', padding: '2px 8px', borderRadius: '10px', fontWeight: 'normal' }}>Chairman — Read Only</span>}
      </span>

      {/* Member navigation */}
      {isMember && (
        <>
          <Link to="/portal"           style={linkStyle}>My Portal</Link>
          <Link to="/financial"        style={{ ...linkStyle, color: '#f39c12', fontWeight: 'bold' }}>Finance Dashboard</Link>
          <Link to="/financial-cycles" style={linkStyle}>Cycle Calendar</Link>
          <Link to="/projections"      style={linkStyle}>Projections</Link>
          <Link to="/gallery"          style={linkStyle}>Gallery</Link>
        </>
      )}

      {/* Credit Officer navigation — Dashboard, Loans, Treasury, Finance only */}
      {isCreditOfficer && (
        <>
          <Link to="/financial"  style={{ ...linkStyle, color: '#f39c12', fontWeight: 'bold' }}>Finance</Link>
          <Link to="/dashboard"  style={linkStyle}>Dashboard</Link>
          <Link to="/loans"      style={linkStyle}>Loans</Link>
          <Link to="/treasury"   style={linkStyle}>Treasury</Link>
        </>
      )}

      {/* Staff navigation (includes Chairman — full read-only oversight) */}
      {isStaff && (
        <>
          <Link to="/financial"        style={{ ...linkStyle, color: '#f39c12', fontWeight: 'bold' }}>Finance</Link>
          <Link to="/dashboard"        style={linkStyle}>Dashboard</Link>
          <Link to="/members"          style={linkStyle}>Members</Link>
          <Link to="/loans"            style={linkStyle}>Loans</Link>
          <Link to="/fines"            style={linkStyle}>Fines</Link>
          <Link to="/rosca"            style={linkStyle}>ROSCA</Link>
          <Link to="/mifl"             style={linkStyle}>MIFL</Link>
          <Link to="/subscriptions"    style={linkStyle}>Subscriptions</Link>
          <Link to="/savings"          style={linkStyle}>Savings</Link>
          <Link to="/treasury"         style={linkStyle}>Treasury</Link>
          <Link to="/expenses"         style={linkStyle}>Expenses</Link>
          <Link to="/secretariat"      style={linkStyle}>Secretariat</Link>
          <Link to="/documents"        style={linkStyle}>Documents</Link>
          <Link to="/payments"         style={linkStyle}>Payments</Link>
          <Link to="/notifications"    style={linkStyle}>Notifications</Link>
          <Link to="/financial-cycles" style={{ ...linkStyle, color: '#2ecc71', fontWeight: 'bold' }}>Cycle Calendar</Link>
          <Link to="/projections"      style={linkStyle}>Projections</Link>
          <Link to="/gallery"          style={linkStyle}>Gallery</Link>
          <Link to="/reports"          style={linkStyle}>Reports</Link>
          <Link to="/audit"            style={{ ...linkStyle, color: '#f39c12' }}>Audit Log</Link>
          {canViewAdminLinks && <Link to="/users"        style={{ ...linkStyle, color: '#f39c12' }}>Users</Link>}
          {canViewAdminLinks && <Link to="/system-jobs"  style={{ ...linkStyle, color: '#e74c3c', fontWeight: 'bold' }}>⚙ Jobs</Link>}
        </>
      )}

      <button onClick={onLogout} style={{
        marginLeft: 'auto',
        background: '#e74c3c',
        color: 'white',
        border: 'none',
        padding: '6px 14px',
        borderRadius: '4px',
        cursor: 'pointer'
      }}>Logout</button>
    </nav>
  );
}

const linkStyle = {
  color: 'white',
  textDecoration: 'none',
  padding: '6px 10px',
  borderRadius: '4px',
  fontSize: '14px'
};

export default Navbar;